import { Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import Keycloak from 'keycloak-js';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, RouterLink, ButtonModule, ToastModule],
  templateUrl: './layout.html'
})
export class Layout {
  private readonly keycloak = inject(Keycloak);

  protected readonly username = (this.keycloak.tokenParsed?.['preferred_username'] as string | undefined) ?? '';

  protected logout(): void {
    void this.keycloak.logout({ redirectUri: window.location.origin });
  }
}
